export { default as OTPInput } from "./otpInput";
